import React, { useEffect } from 'react';
import classnames from 'classnames';
import { map, has, get, noop, isNil } from 'lodash';
import { NavLink as Link } from 'react-router-dom';

// local dependencies
import { LazyImage } from 'modules/lazy-image';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import * as ROUTE_PATHS from 'constants/route-paths';
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';
import { messageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';
import data from  './siteHeaderData.json';

// get store
const store = getStore();

// route views
const ROUTE_VIEWS = {
	'callManagement': ROUTE_PATHS.DASHBOARD,
    'reports': ROUTE_PATHS.REPORTS,
    'administration': ROUTE_PATHS.ADMINISTRATION,
	'accessManagement': ROUTE_PATHS.ACCESS_MANAGEMENT
};

// get a global redux store ( creates empty store if not already created )
// const store = getStore();

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { siteHeader as SiteHeader } from 'ui/views/widgets/siteHeader';
 *
 * // render
 * <SiteHeader propName='propValue'/>
 */
export const siteHeader = ( props ) => {

	let callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

	useEffect( () => {
		messageBus.on( MESSAGE_BUS_EVENTS.CALL_ENDED, updateAction );
		return () => { messageBus.off( MESSAGE_BUS_EVENTS.CALL_ENDED, updateAction ); };
	}, [] );

	const updateAction = () => {
		callId = false;
	};
    
    // get header logo url from the app context
	// const logoUrl = get( store.getState()[ REDUCER.APP_CONTEXT ], 'component.data.context.logoURL', props.logoURL );
	// const logoUrl = '/assets/images/logo-sm.png';
	const logoUrl = 'data:image/png;base64,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';
	
	// dynamic class name
	const widgetClassName = classnames( 'ui-site-header', {
		'ui-site-header--sticky': props.isSticky,
	} );

    return (
		<div className={ widgetClassName }>
			<div className='ui-site-header__content'>
				{/* logo */}
				<Link to={ ROUTE_PATHS.HOME } className='ui-site-header__content__logo'>
					<LazyImage
						preloaderClassName='ui-site-header__content__logo__preloader'
						imageClassName='ui-site-header__content__logo__img'
						src={ data.logoUrl }
						alt='HealthDyne'
						rel='logo image'
					/>
				</Link>

				{/* primary navigations */}
				<div className='ui-site-header__content__primary-nav'>
					{ map( getVisibleItems( props.navigations.primary, props.visibility ), ( nav ) => {

						const className = classnames( 'ui-site-header__content__primary-nav__item', {
							'ui-site-header__content__primary-nav__item--disabled': ! isNil( callId ) && ROUTE_PATHS.DASHBOARD !== ROUTE_VIEWS[ nav.name ]
						} );

						return has( ROUTE_VIEWS, nav.name ) ? (
							<Link
								key={ nav.name }
								to={ ROUTE_VIEWS[ nav.name ] }
								className={ className }
								activeClassName='ui-site-header__content__primary-nav__active'
							>
								{ getLabel( nav.title ) }
							</Link>
						) : (
							<div
								key={nav.name}
								className='ui-site-header__content__primary-nav__item'
							>
								{ getLabel( nav.title ) }
							</div>
						);
					} ) }
				</div>
				{/* tertiary navigation */}
				<div className='ui-site-header__content__tertiary-nav'>
					{ map( getVisibleItems( props.navigations.tertiary, props.visibility ), ( nav ) => {
					    const isButtonVisible = props.visibility.editButton
						// edit epost id
						if( 'editEpostId' === nav.name ) {
							return (
								<div key={ nav.name } className='ui-site-header__content__tertiary-nav__edit-epost-id'>
									<p className='ui-site-header__content__tertiary-nav__edit-epost-id__label'>
										{ getLabel( nav.title ) }
									</p>
									<div className='ui-site-header__content__tertiary-nav__edit-epost-id__value'  onClick={isButtonVisible && props.onEditEpostIdClick }>
										<div className='ui-site-header__content__tertiary-nav__edit-epost-id__value__id'>
											{ get( props.appContext, 'component.data.state.authorization.ePostId' ) }
										</div>
										<div className='ui-site-header__content__tertiary-nav__edit-epost-id__value__icon'>
										{isButtonVisible && <Icon name='edit' width='14' height='14' />}
										</div>
									</div>
								</div>
							);
						}
						
						// return nothing
						return null;
						
					} ) }
				</div>
				

				{/* secondary navigations */}
				<div className='ui-site-header__content__secondary-nav'>
					{ map( getVisibleItems( props.navigations.secondary, props.visibility ), ( nav ) => {
						return (
							<div
								key={ nav.name }
								tabIndex={0}
								className='ui-site-header__content__secondary-nav__item'
								onClick={() => {
									const url = props.headerInfo?.headerUrls[nav.url.refId]
									props.handleLogoutFromHeader(url)
								}}
								onKeyDown={e => {
									if (e.key === 'Enter') {
										const url = props.headerInfo?.headerUrls[nav.url.refId]
										props.handleLogoutFromHeader(url)
									} 
								}}
							>
								<div className='ui-site-header__content__secondary-nav__item__icon'>
									<Icon name={ nav.name } fill={ THEME.themeColorPrimary2 } />
								</div>
								<p className='ui-site-header__content__secondary-nav__item__title'>
									{ getLabel( nav.title ) }
								</p>
							</div>
						);
					} ) }
				</div>

			</div>
		</div>
	);
};

// set display name
siteHeader.displayName = 'siteHeader';

// set default props
siteHeader.defaultProps = {
    navigations: {
        primary: [],
        secondary: [],
	},
	visibility: {},
	isSticky: false,
	appContext: {},
	onEditEpostIdClick: noop,
};

/****************************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { siteHeaderPreloader as SiteHeaderPreloader } from 'ui/views/widgets/siteHeader';
 *
 * // render
 * <SiteHeaderPreloader propName='propValue'/>
 */
export const siteHeaderPreloader = () => {
    return (
        <div className='ui-site-header-preloader'>
			<div className='ui-site-header-preloader__content'>
				{/* logo */}
				<div className='ui-site-header-preloader__content__logo'>
					<div className='ui-site-header-preloader__content__logo__preloader'></div>
				</div>

				{/* primary navigations */}
				<div className='ui-site-header-preloader__content__primary-nav'>
					<div className='ui-site-header-preloader__content__primary-nav__item'>
						<div className='ui-site-header-preloader__content__primary-nav__item__preloader'></div>
					</div>
					<div className='ui-site-header-preloader__content__primary-nav__item'>
						<div className='ui-site-header-preloader__content__primary-nav__item__preloader'></div>
					</div>
				</div>

				{/* secondary navigations */}
				<div className='ui-site-header-preloader__content__secondary-nav'>
					<div className='ui-site-header-preloader__content__secondary-nav__item'>
						<div className='ui-site-header-preloader__content__secondary-nav__item__preloader'></div>
					</div>
					<div className='ui-site-header-preloader__content__secondary-nav__item'>
						<div className='ui-site-header-preloader__content__secondary-nav__item__preloader'></div>
					</div>
				</div>
			</div>
		</div>
    );
};

// set display name
siteHeaderPreloader.displayName = 'siteHeaderPreloader';

// set default props
siteHeaderPreloader.defaultProps = {};
